import { render, staticRenderFns } from "./ModifierItemSelects.vue?vue&type=template&id=724c3226&"
import script from "./ModifierItemSelects.vue?vue&type=script&lang=js&"
export * from "./ModifierItemSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports